import React from "react";
import { MessageCircle } from "lucide-react";

// WhatsApp number without any formatting: +61 449 894 275 → 61449894275
const WHATSAPP_NUMBER = "61449894275";
const WHATSAPP_MESSAGE = encodeURIComponent(
    "Hi Villa Alam Lembongan, I'd love to know more about staying at the villa."
);

const WhatsAppButton = () => {
    return (
        <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-float-btn"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-24 right-6 lg:bottom-11 z-50 group flex items-center gap-3 pl-4 pr-5 py-2.0 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.4)] hover:shadow-[0_12px_32px_rgba(37,211,102,0.55)] hover:scale-[1.03] active:scale-100 transition-all duration-300"
        >
            <span className="relative flex items-center justify-center">
                <span className="absolute inset-0 rounded-full bg-white/40 animate-ping" />
                <MessageCircle
                    size={20}
                    strokeWidth={2}
                    className="relative"
                    fill="white"
                />
            </span>
            <span className="text-xs tracking-[0.18em] uppercase font-medium hidden sm:inline">
                Chat on WhatsApp
            </span>
        </a>
    );
};

export default WhatsAppButton;
